import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import SonusLogo from '../assets/sonus.png';

const Navbar = () => {
  const location = useLocation();
  
  return (
    <div className="navbar">
      <div className="logo-container">
        <img src={SonusLogo} alt="Sonus Logo" className="logo" />
        <span className="logo-text">Sonus</span>
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {location.pathname === '/swap' ? (
          <Link to="/" className="claim-button">Claim</Link>
        ) : (
          <Link to="/swap" className="claim-button">Swap</Link>
        )}
        
        <ConnectButton.Custom>
          {({
            account,
            chain,
            openAccountModal,
            openChainModal,
            openConnectModal,
            mounted,
          }) => {
            return (
              <div
                {...(!mounted && {
                  'aria-hidden': true,
                  'style': {
                    opacity: 0,
                    pointerEvents: 'none',
                    userSelect: 'none',
                  },
                })}
              >
                {(() => {
                  if (!mounted || !account || !chain) {
                    return (
                      <button onClick={openConnectModal} className="connect-wallet-button">
                        Connect Wallet
                      </button>
                    );
                  }

                  if (chain.unsupported) {
                    return (
                      <button onClick={openChainModal} className="connect-wallet-button">
                        Wrong network
                      </button>
                    );
                  }

                  return (
                    <button onClick={openAccountModal} className="connect-wallet-button">
                      {account.displayName}
                    </button>
                  );
                })()}
              </div>
            );
          }}
        </ConnectButton.Custom>
      </div>
    </div>
  );
};

export default Navbar;